export const T = {
  en_GB: {
    profile: "Profile",
    managePersonalInfo: "Manage your personal information",
  },
  nb_NO: {
    profile: "Profil",
    managePersonalInfo: "Administrer din personlige informasjon",
  },
} as const;
